import { render, staticRenderFns } from "./CriterionPills.vue?vue&type=template&id=36803940&"
import script from "./CriterionPills.vue?vue&type=script&lang=js&"
export * from "./CriterionPills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36803940')) {
      api.createRecord('36803940', component.options)
    } else {
      api.reload('36803940', component.options)
    }
    module.hot.accept("./CriterionPills.vue?vue&type=template&id=36803940&", function () {
      api.rerender('36803940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/criterion/template/CriterionPills.vue"
export default component.exports